// extracted by mini-css-extract-plugin
module.exports = {"hide":"CompanyInformation_hide__36SUI"};